var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeveLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6576 27.7741L13.7694 35.5643L11.6626 34.3428L10.7606 27.3238L7.77248 32.0861L5.67645 30.8705L10.5647 23.0803L12.6607 24.2959L13.5627 31.3149L16.5513 26.5522L18.6576 27.7741Z",
    fill: "#185D63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2005 6.1923L27.3124 13.9825L25.2055 12.761L24.3035 5.74195L21.3148 10.5048L19.2189 9.28917L24.1071 1.49902L26.2031 2.71462L27.1051 9.73369L30.0938 4.97089L32.2005 6.1923Z",
    fill: "#185D63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32484 18.2616L1.22119 13.562L2.49178 11.5368L9.79331 10.6697L4.83883 7.79667L6.10336 5.78174L14.2065 10.4813L12.942 12.4962L5.64048 13.3633L10.595 16.2363L9.32484 18.2616Z",
    fill: "#E3C182"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7748 31.2802L23.6711 26.581L24.9419 24.5558L32.2434 23.6888L27.2889 20.8158L28.5534 18.8008L36.6571 23.4999L35.3924 25.5149L28.0909 26.3819L33.0454 29.2548L31.7748 31.2802Z",
    fill: "#007499"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8028 12.7968L32.0932 15.6626L36.7729 16.5651L37.5694 19.6593L28.3422 17.5138L27.8647 15.6604L34.9985 9.67163L35.8028 12.7968Z",
    fill: "#E2C4B9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.76659 24.758L5.47616 21.8922L0.796507 20.9897L0 17.8955L9.22726 20.041L9.70459 21.8945L2.57102 27.8827L1.76659 24.758Z",
    fill: "#ECA102"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0063 35.1369L22.0251 31.571L21.0863 36.0694L17.8676 36.8351L20.0994 27.965L22.0273 27.5061L28.2571 34.3636L25.0063 35.1369Z",
    fill: "#00242C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5635 2.41676L15.5447 5.98281L16.4835 1.4842L19.7022 0.718506L17.4704 9.58879L15.5424 10.0477L9.31262 3.19008L12.5635 2.41676Z",
    fill: "#F9EEE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeveLogoSmall);
export default __webpack_public_path__ + "static/media/neve-logo-small.2f6351303b989a249a13618b7986361b.svg";
export { ForwardRef as ReactComponent };